import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class PaginationService {
  startIndex: number = 1;
  endIndex: number = 0;
  dataLength: number = 0;

  public currentPage = new BehaviorSubject<number>(1);
  _currentPageObservable$ = this.currentPage.asObservable();

  onPageChange(pageNumber: number): void {
    this.currentPage.next(pageNumber);
  }
}
